import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { NotificationContract } from '../contracts/notification.contract';

export const notificationsActions = createActionGroup({
  source: 'Users',
  events: {
    showNotification: props<{
      notification: NotificationContract;
      foregroundOnlyNotification?: boolean;
    }>(),
    dismiss: emptyProps(),
  },
});
